import { SubscriptionConst } from '@/constants'
import { Tenant, UserRoleDefinition, UserTenantListMap } from '@/store/modules/app/types'
import { FileType, StandardObject } from '@/store/types'
import { orderBy } from 'lodash'

export default {
  // eslint-disable-next-line lines-around-comment
  /**
   * Retrieves an array of allowed file extensions based on `dynaconfConfig`.
   * The result is a flattened array of file extensions.
   *
   * @returns { string[] } An array of allowed file extensions.
   */
  allowedModelFileFormats(state: any): string[] {
    return state.dynaconfConfig.fileformats.fileTypes
      .filter((f: FileType) => f.enabled && f.uploadType === '3D Models')
      .map((f: FileType) => f.extensions)
      .flat()
  },
  orderedTenantUserRoles(state: any): UserRoleDefinition[] {
    return orderBy(state.tenantUserRoles, ['DisplayName'], ['asc'])
  },
  tenantUserRolesMap(state: any): StandardObject {
    const rolesMap: StandardObject = {}

    state.tenantUserRoles.forEach((role: UserRoleDefinition) => {
      // role.Name: role_teamadmin1, role_creator1 etc.
      rolesMap[role.Name.toLowerCase()] = role
    })

    return rolesMap
  },
  userTenantsDropdownMap(state: any): UserTenantListMap[] {
    return state.myTenants.map((tenant: Tenant) => ({
      text: tenant.Name,
      value: tenant.ID,
    }))
  },
  isFreeTier(state: any): boolean {
    return state.myTenant.Subscription.TierType === SubscriptionConst.Subscription.subscriptionTierFree
  },
  isOrgTier(state: any): boolean {
    return state.myTenant.Subscription.TierType === SubscriptionConst.Subscription.subscriptionTierOrganization
  },
  tenantDefaultInfo(state: any): any {
    const targetPricingSet = state.dynaconfConfig.pricing.sets[state.myTenant.Subscription.PricingSet]
    return targetPricingSet.tiers[state.myTenant.Subscription.TierType]
  },
  maxJigs(state: any): number {
    if (state.myTenant.Subscription.SubscriptionFeatures != null && state.myTenant.Subscription.SubscriptionFeatures.CustomFeatures.MaxJigs != null) {
      return state.myTenant.Subscription.SubscriptionFeatures.CustomFeatures.MaxJigs
    }

    return state.myTenant.Subscription.MaxJigs
  },
  maxSeatsIncluded(state: any): number {
    const seatsIncluded: number =
      typeof state.myTenant.Subscription.SeatsIncludedInTier !== 'number' ? 0 : state.myTenant.Subscription.SeatsIncludedInTier
    const additionalSeats: number =
      typeof state.myTenant.Subscription.AdditionalSeats !== 'number' ? 0 : state.myTenant.Subscription.AdditionalSeats
    return seatsIncluded + additionalSeats
  },
  maxTeamStorageLimitMB(state: any): number {
    if (state.myTenant.Subscription.SubscriptionFeatures != null && state.myTenant.Subscription.SubscriptionFeatures.CustomFeatures.TeamStorageLimitMB != null) {
      return state.myTenant.Subscription.SubscriptionFeatures.CustomFeatures.TeamStorageLimitMB
    }

    return state.myTenant.Subscription.TeamStorageLimitMB
  },
  modelUploadMaxSizeMB(state: any): number {
    return state.myTenant.Subscription.ModelUploadMaxSizeMB
  },
}
